/**
 * o16-reduced-motion.js
 * Pauses Swiper autoplay and all autoplaying videos when the user's OS
 * reports prefers-reduced-motion: reduce.
 * Runs once on DOMContentLoaded; also re-checks on mediaQuery change
 * (covers OS setting toggle without reload).
 */
(function () {
  'use strict';

  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');

  function applyReducedMotion(matches) {
    if (!matches) return;

    // ── Pause Swiper instances ────────────────────────────────────────
    // Swiper registers instances on swiper.el — iterate all swiper elements.
    var swiperEls = document.querySelectorAll('.swiper');
    swiperEls.forEach(function (el) {
      if (el.swiper && typeof el.swiper.autoplay === 'object') {
        el.swiper.autoplay.stop();
      }
    });

    // ── Pause autoplaying videos ──────────────────────────────────────
    var videos = document.querySelectorAll('video[autoplay], video[data-autoplay]');
    videos.forEach(function (v) {
      v.pause();
      // Remove autoplay so subsequent DOM inserts also pause
      v.removeAttribute('autoplay');
    });
  }

  // Run on initial load
  document.addEventListener('DOMContentLoaded', function () {
    applyReducedMotion(mq.matches);
  });

  // Re-run if OS setting changes while page is open
  mq.addEventListener('change', function (e) {
    applyReducedMotion(e.matches);
  });

  // Re-run after Shopify section loads (editor hot-reload)
  document.addEventListener('shopify:section:load', function () {
    applyReducedMotion(mq.matches);
  });
})();
